import { useEffect, useRef, useState } from 'react'

/**
 * PRESENCE (LOT 5.5.2) — cycle de vie d'entrée/sortie des surfaces.
 *
 * Une modale ne disparaît plus instantanément : quand `open` passe à false,
 * elle reste montée le temps de son animation sortante (`data-state="closing"`
 * en CSS), puis quitte le DOM. L'appelant rend tant que `mounted` est vrai
 * et pose `data-state` sur la surface ET son backdrop.
 *
 * Le mouvement réduit est géré par le CSS (durées quasi nulles) — garder le
 * même délai JS est sans effet visible et évite une double source de vérité.
 */
export function usePresence(open: boolean, exitMs = 200): { mounted: boolean; state: 'open' | 'closing' } {
  const [mounted, setMounted] = useState(open)
  const [closing, setClosing] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined)

  useEffect(() => {
    if (open) {
      clearTimeout(timer.current)
      setMounted(true)
      setClosing(false)
      return
    }
    if (!mounted) return
    setClosing(true)
    timer.current = setTimeout(() => { setMounted(false); setClosing(false) }, exitMs)
    return () => clearTimeout(timer.current)
  }, [open]) // eslint-disable-line react-hooks/exhaustive-deps

  return { mounted, state: closing ? 'closing' : 'open' }
}
